export class CaracPretModel {
       dtSignatureContratPret : Date;
       mtEcheancePret : number;
}